<template>
  <div class="header">
    <div class="logo mini">
      <a href="/DocList"></a>
      <button class="btn-lnb" id="btnLnb" title="접기" @click="mainMenuAction()">메뉴</button>
    </div>
    <div class="notice">
      <marquee font scrolldelay="100" scrollamount=10>
        <!-- <font size="3" face="Verdana"> -->
          <font color="black" v-for="(item, idx) in banners" :key="idx">
            <!-- <a href="#" @click="noticePopModal(item)">{{ item.docNm }}</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
            <el-link class="marqueelink" @click="noticePopModal(item)" :underline="false" style="margin-right: 65px; color: black !important;">{{ item.docNm }}</el-link>
          </font>
        <!-- </font> -->
      </marquee>
    </div>
    <div v-if="(this.$store.state.loginInfo.groupUId === 5 || this.$store.state.loginInfo.groupUId === 6)" class="user-info">
      <span class="user-msg">
        <el-button v-if="$store.state.loginInfo.groupUId !== 29" type="danger" icon="el-icon-message-solid" @click="todoListPopup" size="small" style="margin-right: 5px;" circle></el-button>
        <span class="point-blue">{{ this.$store.state.loginInfo.userName }}</span>
        <span>({{ this.$store.state.loginInfo.loginId }})</span>
      </span>
      <a href="/DocList" class="ico ico-home" title="HOME"></a>
      <!--<a href="#" title="비밀번호 변경" @click="changePwPop"> <i class="fas fa-key" style="margin-top:22px; font-size:15px; color: #777777;"></i></a>-->
      <a href="#" class="ico ico-logout" title="로그아웃" @click="logout"></a>
    </div>
    <div v-else class="user-info">
      <span class="user-msg">
        <el-button v-if="$store.state.loginInfo.groupUId !== 29" type="danger" icon="el-icon-message-solid" @click="todoListPopup" size="small" style="margin-right: 5px;" circle></el-button>
        <span class="point-blue">{{ this.$store.state.loginInfo.userName }}</span>
        <span>({{ this.$store.state.loginInfo.loginId }})</span>
      </span>
      <a href="/DocList" class="ico ico-home" title="HOME"></a>
      <!--<a href="#" title="비밀번호 변경" @click="changePwPop"> <i class="fas fa-key" style="margin-top:22px; font-size:15px; color: #777777;"></i></a>-->
      <a href="#" class="ico el-icon-message" title="SMS 발송" style="" @click="SendSms"></a>
      <a href="#" class="ico ico-logout" title="로그아웃" @click="logout"></a>
    </div>
  </div>
</template>

<script>

import ChangePwPop from '@/components/ChangePwPop.vue';
import PopDocReadPop from '@/components/Bbs/PopDocRead2.vue';
import SendSms from '@/components/SendSms';

export default {
  name: 'Navbar',
  props: {
    msg: String,
  },

  data() {
    return {
        authority:"",
        banners: [{
          key: '01',
          value: 'first'
        },{
          key: '02',
          value: 'second'
        },{
          key: '03',
          value: 'third'
        }],
        isNoticeShow: false,
    };
  },
  computed:{
    classObj() {
      return {
        'navbar-item': true,
        'is-hoverable': true,
      }
    },
  },
  mounted() {

    try{
      this.authority = this.$store.state.loginInfo.authorities[0].roleCd;
    // eslint-disable-next-line no-empty
    } catch(e) {
      
    }

    // Get all "navbar-burger" elements
    const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

    // Check if there are any navbar burgers
    if ($navbarBurgers.length > 0) {
      // Add a click event on each of them
      $navbarBurgers.forEach((el) => {
        el.addEventListener('click', () => {
          // Get the target from the "data-target" attribute
          const { target } = el.dataset;
          const $target = document.getElementById(target);

          // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
          el.classList.toggle('is-active');
          $target.classList.toggle('is-active');
        });
      });
    }
    
  },

  methods: {
    todoListPopup() {
      this.isNoticeShow = !this.isNoticeShow;
      $('.todo-box').css('display', this.isNoticeShow ? 'none' : 'flex');
      $('.todo-box').css('top', '40px');
      $('.todo-box').css('right', this.isNoticeShow ? '0' : '20px');
    },
    logout() {
      this.$http
        .get('/api/logout')
        .then(() => {
          this.$store.commit('logout');
          this.$cookie.delete('loginInfo');
          this.$router.push({path: `/login`}).catch(()=>{});
        })
        .catch((e) => {
          // eslint-disable-next-line no-console
          console.error(e);
        });
    },
    changePwPop(){
      // eslint-disable-next-line no-unused-vars
      let vm = this
      
      this.$modal.open({
          component: ChangePwPop,
          // props: {
          //   param: this.string
          // },
          parent: this,
          width: 500,
          events: {
              // eslint-disable-next-line no-unused-vars
              close(value) {
              }
          }
      }) 
    },
    SendSms() {
      let vm = this;

      this.$modal.open({
        component: SendSms,
        parent: this,
        width: 800,
        height: 550,
        events: {
          close(value) {}
        }
      })
    },
    mainMenuAction(){
      if ($(".lnb").hasClass("minimized")) {
        $(".lnb").removeClass("minimized");
        $(".header > .logo").removeClass("mini");
        $(".header .logo > a > img.logo-big").css("display", "inline-block");
        $(".header .logo > a > img.logo-mini").css("display", "none");
        $("#btnLnb").attr("title", "접기");
        
        $(".header > .logo").removeClass("mini");
        if ($(".menu-depth01 > li").hasClass("hide")) {
            $(".menu-depth01 > li.open").removeClass("hide");
            //토글 상태 초기화
            if ($(".menu-depth01 > li.open > .menu-depth02").css("display", "none")) {
                $(".menu-depth01 > li.open > .menu-depth02").css("display", "block");
            } else {
                $(".menu-depth01 > li.open > .menu-depth02").css("display", "none");
            }
            $(".menu-depth01 > li.open > .menu-depth02").css("display", "none");
            $(".menu-depth01 > li.open > .menu-depth02").toggle();
        }
      } else {
          $(".lnb").addClass("minimized");
          $(".header > .logo").addClass("mini");
          $(".header .logo > a > img.logo-big").css("display", "none");
          $(".header .logo > a > img.logo-mini").css("display", "inline-block");
          $("#btnLnb").attr("title", "펼치기");

          if ($(".menu-depth01 > li").hasClass("open")) {
              $(".menu-depth01 > li.open").addClass("hide");
              //토글 상태 초기화
              if ($(".menu-depth01 > li.open.hide > .menu-depth02").css("display", "block")) {
                  $(".menu-depth01 > li.open.hide > .menu-depth02").css("display", "none");
              } else {
                  $(".menu-depth01 > li.open.hide > .menu-depth02").css("display", "block")
              }
              $(".menu-depth01 > li.open.hide > .menu-depth02").css("display", "block");
              $(".menu-depth01 > li.open.hide > .menu-depth02").toggle();
          }
      }
    },
    getNotices() {
      const {asAgentId, compCd} = this.$store.state.loginInfo;
      if(asAgentId && compCd) {
        this.$store.commit('loading');
          this.$http.post(`/api/boardMng/notice/list`,{
            companyId: compCd,
            srcId1: 'Home',
            srcId2: 'Notice',
            srcId3: "",
            srcId4: "",
            searchType: "",
            searchTxt: "",
            startDt: this.$moment(new Date()).format('YYYY-MM-DD'),
            endDt: this.$moment(new Date()).format('YYYY-MM-DD'),
            asAgentId: asAgentId,
            sortType : "",
            page : 1,
            totalPage : 5,
            totalCount : 1,
            curPage : 1,
            processTime : ""
        })
        .then(response => {
            this.banners = response.data;
        }).finally(() => {
          this.$store.commit('finish');
        });
      } else {
        this.banners = [];
      }
    },
    noticePopModal(item) {
      this.$modal.open({
          component: PopDocReadPop,
          props: {
            custParam: item,
            title: `공지사항`
          },
          parent: this,
          width: 500,
          events: {
              // eslint-disable-next-line no-unused-vars
              close(value) {
              }
          }
      }) 
    }
    
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/common";

.spacer {
  width: 80px;
}

.navbar {
  background-color: $green;
  font-weight: bold;
}
</style>
<style scoped>
.marqueelink:hover {
    text-decoration: underline;
    text-decoration-color: red;
    -webkit-text-decoration-color: red;
}
</style>
